export default Object.freeze({
  LISTING_DETAILS: "ListingDetails",
  LISTING_EDIT: "ListingEdit",
  LOGIN: "Login",
  MESSAGES: "Messages",
  REGISTER: "Register",
  WELCOME: "Welcome",
  ACCOUNT: "Account",
  USER_FIXO: "Account",
  PROFILE_EDIT_SCREEN: "ProfileEdit",
  LISTING_SCREEN: "Listing",
  SEARCH_USER: "Search",
  FOUND_USER: "FoundUser",
  FOLLOWERS_SCREEN: "Followers",
  FOLLOWED_SCREEN: "Followed",
  LISTING_LIKE_USER_PUBLICATION: "ListingLikePublication",
  COMMENST_PUBLICATIONS: "CommentsPublication",
  SELECT_ADDING: "Select",
  LISTING_EDIT: "AddPublication",
  ADD_SEED: "AddSeed",
  SEED_DETAILS: "Seed Details",
  LISTINGS_SEEDS: "Listings Seed",
  USER_SCREEN: "User Fixo",
  NO_BOTTON: "My Actions",
  ADD_ACTION: "AddAction",
  MODAL_ACTION_LIST: "Action List",
  COMMENTS_SEEDS: "Comments Seeds",
  NO_BOTON_FOUND_USER: "Found User",
  CHAT: "Chat",
  CHAT_USER_LIST: "Chat List",
  FEED_SCREEN: "Feed",
  ADD_COMPONENT: "Working on",
  ACTION_EDIT_SCREEN: "Editing",
  NOTIFICATION_SCREEN: "Notifications",
  NOTIFICATION_TYPE_SCREEN: "Notifications ",
  SEARCH_SEED: "Search Seed",
  EDITAR_PERFIL: "Editar perfil",
  ADD_HISTORY: "Agregar historia",
  DETAIL_HITORY: "Historia",
  HISTORY_SCREEN: "HistoriaS",
  IMAGE_VISOR:"Imagen"
});
